/* The unread dot on the header's News item.

   Shown only to a signed-in customer, and only while the newest announcement
   is newer than the last one they have seen. Opening the news page writes that
   timestamp (assets/gs-announcements.js), which is what clears it.

   The "seen" mark is per browser, in localStorage: there is nowhere on a
   customer record to keep it without an app, and a read receipt is not worth
   one. In a fresh browser the dot shows once and then stays quiet. */

(function () {
  'use strict';

  var SEEN_KEY = 'gs-ann-seen';

  var node = document.getElementById('gs-ann-state');
  if (!node) return;

  var state;
  try {
    state = JSON.parse(node.textContent);
  } catch (err) {
    return;
  }

  if (!state || !state.signedIn || !state.latest) return;

  var seen = 0;
  try {
    seen = parseInt(window.localStorage.getItem(SEEN_KEY), 10) || 0;
  } catch (err) {
    seen = 0;
  }

  if (state.latest <= seen) return;

  /* Already on the news page: the strip's own script clears it. */
  if (window.location.pathname.indexOf(state.path || '/blogs/news') === 0) return;

  function label(link) {
    var t = link.querySelector('.menu-list__link-title');
    return (t || link).textContent.trim().toLowerCase();
  }

  function mark() {
    var links = Array.prototype.slice.call(
      document.querySelectorAll('a[href]')
    ).filter(function (a) {
      if (a.closest('.gs-ann')) return false;
      var href = a.getAttribute('href') || '';
      var hit = href.indexOf(state.path) === 0 || label(a) === 'news';
      return hit && !a.querySelector('.gs-newdot');
    });

    if (!links.length) return false;

    links.forEach(function (a) {
      var host = a.querySelector('.menu-list__link-title') || a;
      var dot = document.createElement('span');
      dot.className = 'gs-newdot';
      dot.setAttribute('aria-hidden', 'true');
      host.appendChild(dot);
      a.setAttribute('aria-label', (a.textContent.trim() || 'News') + ' — new announcement');
    });

    return true;
  }

  /* The header rebuilds its list on load and on resize (overflow-list moves
     items into "More"), so try again a couple of times rather than once. */
  if (!mark()) window.setTimeout(mark, 400);
  window.setTimeout(mark, 1400);
})();
